import { UserService } from './../base-services/user.service';
import { Pipe, PipeTransform } from "@angular/core";
import { DatePipe, DecimalPipe } from "@angular/common";

@Pipe({
    name: 'getPropertyValue',
    pure: true
})
export class GetPropertyValuePipe implements PipeTransform {
    constructor(
        private datePipe: DatePipe,
        private decimalPipe: DecimalPipe,
        private userService: UserService
    ){}

    transform(value: any, args?: any): string {
        return value.item[value.column.Name] != null && value.item[value.column.Name] !== '' ? this.getPropertyValue(value.item, value.column.Name, value.column.Type, value.column.Format) : '';
    }

    private getPropertyValue(item: any, property: string, type: string, format: string){
        if(property.indexOf('.') == -1)
            return this.getValue(item[property], type, format);
        else
            return this.getPropertyValue(item[property.split('.')[0]], property.split('.')[1], type, format);
    }

    private getValue(propertyValue: any, type: string, format: string){
        if(propertyValue == null)
            return null;
        
        switch(type){
            case 'text': return propertyValue;
            case 'datetime': return this.datePipe.transform(propertyValue, format, '', this.userService.GetLocaleString());
            case 'number': return this.decimalPipe.transform(propertyValue, format, this.userService.GetLocaleString());
            case 'date': return this.datePipe.transform(propertyValue, format);
            //case 'ngbDate': return this.datePipe.transform(new Date(propertyValue.year.toString() + this.userService.GetDateSeparator() + (propertyValue.month).toString() + this.userService.GetDateSeparator() + propertyValue.day.toString()), format);
            case 'ngbDate': return this.datePipe.transform(new Date(propertyValue.year.toString() + '/' + propertyValue.month.toString() + '/' + propertyValue.day.toString()), format);
            case 'boolean': return (propertyValue == true) ? "<span class='fa fa-fw fa-check'></span>" : '';
            default: return propertyValue;
        }
    }
}